import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import get from 'lodash/get';

export default class MCPBar extends Component {
  constructor(props) {
    super(props);

    this.navigate = this.navigate.bind(this);

    this.state = {
      categories: []
    };

    this.currentArticle = this.props.url
      ? this.props.url.replace(
          /^.+:\/\/((www.)?fastcompany\.com|fastcompany\.local:8880)\//,
          '/'
        )
      : '';
  }

  componentDidMount() {
    axios
      .get(
        'https://fc-api.fastcompany.com/api/v1/id/fastcompany/90523229' // THIS NEEDS TO CHANGE
      )
      .then(data => {
        const post = get(data, 'data.posts[0]', {});
        const mcpData = get(post, 'acf.mcp_list', {});

        const categories = [];

        // eslint-disable-next-line no-restricted-syntax
        for (const property in mcpData) {
          if (property.includes('cat_entries_')) {
            if (mcpData[property].display_name === '') {
              // eslint-disable-next-line no-continue
              continue;
            }
            categories.push(mcpData[property]);
          }
        }

        this.setState({ categories });
      });
  }

  navigate(e) {
    window.location.href = e.target.value;
  }

  render() {
    const categories = get(this.state, 'categories', []);

    return (
      <nav className="mcp-bar">
        <div className="header">
          <a href="/most-creative-people/2020">Most Creative People</a>
        </div>

        <select value={this.currentArticle} onChange={this.navigate}>
          {categories.map(category => {
            const label = get(category, 'display_name', '');
            const entries = get(category, 'entries', []);

            return (
              <optgroup label={label.toUpperCase()}>
                {entries.map(entry => (
                  <option
                    value={entry.url.replace(
                      /^.+:\/\/((www.)?fastcompany\.com|fastcompany\.local:8880)\//,
                      '/'
                    )}
                  >
                    {entry.name}
                  </option>
                ))}
              </optgroup>
            );
          })}
        </select>

        {/* <select value={this.currentArticle} onChange={this.navigate}>
          <optgroup label="Winners">
            {this.entries.winners.map(entry => (
              <option value={entry.url}>{entry.name}</option>
            ))}
          </optgroup>

          <optgroup label="Finalists">
            {this.entries.finalists.map(entry => (
              <option value={entry.url}>{entry.name}</option>
            ))}
          </optgroup>
        </select> */}
      </nav>
    );
  }
}

MCPBar.propTypes = {
  url: PropTypes.string.isRequired
};
